import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Product, TranslationService } from 'gast-common-ng';
import { ClozeTestStyleModel } from 'gast-onset-ng/lib/cloze-test/model/cloze-test-style-model';
import { AuthService, CommonPortalUrlService } from 'gast-portal-ng';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UrlService } from 'src/shared/services/common/url.service';

@Component({
  selector: 'app-onset-study-home',
  templateUrl: './onset-study-home.component.html',
  styleUrls: ['./onset-study-home.component.css']
})
export class OnsetStudyHomeComponent implements OnInit, OnDestroy {
  mobileMode: boolean;
  environment;

  lang = 'DE';

  cTestLogo: string;
  clozeTestStyleModel: ClozeTestStyleModel;

  username: string;
  enoughMobileParticipant = false; // 100 is cut off
  cTestButtonColor: string;

  intervalId: any;

  constructor(
    private deviceService: DeviceDetectorService,
    public commonPortalUrlService: CommonPortalUrlService,
    private authService: AuthService,
    private urlService: UrlService,
    public translationService: TranslationService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  ngOnInit() {
    // detect mobile
    this.mobileMode = this.deviceService.isMobile();
    this.clozeTestStyleModel = this.generateClozeTestStyle();
    this.cTestButtonColor = this.clozeTestStyleModel.onsetColor;
    // sett logo and button color
    this.cTestLogo = 'onset-assets/img/onset_logo.png';

    // handle language
    this.route.queryParams.subscribe(params => {
      if (params.lang) {
        const lang = params.lang.toLocaleLowerCase();
        this.lang = lang.toLocaleUpperCase();
        this.changeLanguage(lang);
      }
    });
  }

  changeLanguage(lang: string) {
    this.translationService.changeLanguageUsingCode(lang);
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: { lang: lang.toLocaleLowerCase() },
        queryParamsHandling: 'merge'
      });
  }

  login(): void {
    window.location.href = this.commonPortalUrlService.getPortalAccountLoginUrl(
      Product.ONSET, this.translationService, this.urlService.onSETPortalExamUrl() + 'onset-study');
  }

  register(): void {
    window.location.href = this.commonPortalUrlService.getPortalAccountRegisterUrl(
      Product.ONSET, this.translationService, this.urlService.onSETPortalExamUrl() + 'onset-study');
  }

  private generateClozeTestStyle(): ClozeTestStyleModel {
    // TODO config
    const model = {} as ClozeTestStyleModel;
    model.siteBackground = '#ffffff';
    model.exerciseBackground = '#EEF3F8';
    model.frameColor = '#92aac1';
    model.barColor = '#b3c9de';
    model.specialCharacterListColor = '#b3c9de';
    model.specialChcaracterTextColor = '#000000';
    model.exerciseTextColor = '#000000';
    model.buttonsColor = '#fa9463';
    model.testdafColor = '#57a7d6';
    model.onsetColor = '#a5d8db';
    model.duoColor = '#ed6a5b';
    model.testasColor = '#fac075';
    model.font = 'arial, helvetica, sans-serif';
    model.fontSize = '11pt';
    model.displayLogo = true;
    model.cTestInformationUrl = 'http://www.wikipedia.com/';
    return model;
  }
}
